export default {
    methods: {
        /**
         * Assert if customer can pay by Apple Pay.
         * 1. Check if ApplePaySession is available
         * 2. Check if ApplePaySession supports version 3
         * 3. Check if ApplePaySession can make payments
         * @returns {boolean}
         * @see https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/checking_for_apple_pay_availability
         */
        canUseApplePay() {
            if (!this.braintreeInstance) {
                return false;
            }
            if (!this.canUseCreditCard()) {
                return false;
            }
            if (window.ApplePaySession) {
                if (!ApplePaySession.supportsVersion(3)) {
                    console.error("This device does not support version 3 of Apple Pay");
                    return false;
                }
                if (!ApplePaySession.canMakePayments()) {
                    console.error(
                        "This device is not capable of making Apple Pay payments"
                    );
                    return false;
                }
                // This device supports version 3 of Apple Pay.
                return true;
            }
            return false;
        },
        /**
         * Assert if customer can pay by credit card.
         * 1. Check invoice object for cc restrictions.
         * @returns {boolean}
         */
        canUseCreditCard() {
            if (!this.braintreeInstance) {
                return false;
            }
            const ccPayCode = Number(this.invoice.cc_pay_code);
            if ([501, 502, 503, 504].indexOf(ccPayCode) !== -1) {
                return false;
            }
            // No restricted items continue as normal
            return true;
        },
        /**
         * Assert if customer can pay by Google Pay.
         * 1. Check if Google Pay is available
         * 2. Check if Google Pay is ready
         * @returns {boolean}
         */
        canUseGooglePay() {
            if (!this.braintreeInstance) {
                return false;
            }
            if (!this.canUseCreditCard()) {
                return false;
            }
            return true;
        },
        /**
         * Assert if customer can pay by PayPal.
         * 1. Check if PayPal is available
         * 2. Check if PayPal is ready
         * @returns {boolean}
         */
        canUsePayPal() {
            if (!this.braintreeInstance) {
                return false;
            }
            if (!this.canUseCreditCard()) {
                return false;
            }
            return true;
        },
        /**
         * Assert if customer can pay by Venmo.
         * 1. Check if Venmo is available
         * 2. Check if Venmo is ready
         * @returns {boolean}
         */
        canUseVenmo() {
            if (!this.braintreeInstance) {
                return false;
            }
            if (!this.canUseCreditCard()) {
                return false;
            }
            return true;
        },
        /**
         * Assert if customer can pay by Zelle.
         * @returns {boolean}
         */
        canUseZellePayment() {
            // Call canUseZelle from InvoiceValidateMixin
            if(!this.canUseZelle(this.invoice)){
                return false;
            }
            return true;
        },
        /**
         * Assert if customer can pay by E-Check (ACH).
         * @returns {boolean}
         */
        canUseECheck() {
            if (this.invoice.customer_international) {
                return false;
            }
            if (!this.braintreeInstance) {
                return false;
            }
            // canUseBraintree is in InvoiceValidateMixin
            if (!this.canUseBraintree(this.invoice)) {
                return false;
            }
            return true;
        },
        /**
         * Assert if customer can pay by Wire Transfer.
         * @returns {boolean}
         */
        canUseWireTransfer() {
            return true;
        },
        disablePaymentMethod: function (paymentMethod) {
            this.filteredPaymentMethods.forEach(function (method) {
                if (method.component.name === paymentMethod) {
                    method.disabled = true;
                }
                return method;
            });
        }
    },
}